import React from "react";
import gql from "graphql-tag";
import { VictoryPie } from "victory";
import { Box, Text, Flex } from "@atoms";
import { constants } from "@services";
import {
  FundsPageEarningsChartFragment,
  FundsPageEarningsChartFragment_goal,
} from "./__generated__/FundsPageEarningsChartFragment";

// == Types ================================================================

interface IProps {
  campaign: FundsPageEarningsChartFragment;
}

// == Constants ============================================================

FundsPageEarningsChart.fragments = gql`
  fragment FundsPageEarningsChartFragment on Campaign {
    id
    goal {
      dollarsAmount
      formatted
    }
    amountRaised {
      dollarsAmount
      formatted
    }
    amountRaisedBreakdown {
      bonuses {
        dollarsAmount
      }
      shopping {
        dollarsAmount
        formatted
      }
      donations {
        dollarsAmount
      }
    }
  }
`;

// == Functions ============================================================

const goalFormattedStringMaker = (goal: FundsPageEarningsChartFragment_goal) => {
  return goal?.formatted.length > 10 ? `of ${goal?.formatted}` : `of ${goal?.formatted} goal`;
};

// == Component ============================================================

export default function FundsPageEarningsChart({ campaign }: IProps) {
  const {
    amountRaisedBreakdown: { bonuses, shopping, donations },
    amountRaised,
    goal,
  } = campaign;

  const goalRemaining = goal?.dollarsAmount ? goal.dollarsAmount - amountRaised.dollarsAmount : "";

  const chartData = [
    { y: shopping.dollarsAmount },
    { y: donations.dollarsAmount },
    { y: bonuses.dollarsAmount },
    { y: goalRemaining },
  ];

  return (
    <Flex alignItems="center" bg="lightBlueBg" flexDirection="column" width={3 / 5}>
      <Flex alignItems="center" flexDirection="column" justifyContent="center" width={1}>
        <VictoryPie
          colorScale={constants.CHART_COLORS}
          data={chartData}
          innerRadius={130}
          labels={() => ""}
          radius={170}
        />
        <Box position="absolute" textAlign="center">
          <Box textAlign="center">
            <Text fontSize={amountRaised.formatted.length > 9 ? [1, 3, 5] : [2, 4, 5]}>
              {amountRaised.formatted}
            </Text>
          </Box>
          {goal?.formatted && (
            <Box textAlign="center">
              <Text color="primary" fontSize={[0, 1, 2]}>
                {goalFormattedStringMaker(goal)}
              </Text>
            </Box>
          )}
        </Box>
      </Flex>
    </Flex>
  );
}

// == Styles ===============================================================
